<template>
  <div class="city-button" :class="{ 'coming-soon': !available }">
    <!-- Tag Coming Soon -->
    <div v-if="!available" class="coming-soon-tag">
      Coming Soon
    </div>
    
    <div class="city-content" :class="{ 'coming-soon-content': !available }">
      <div class="city-image">
        <img :src="imageUrl" :alt="cityName" />
      </div>
      <div class="city-name">{{ cityName }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  cityName: string;
  imageUrl: string;
  available?: boolean;
}>();

defineEmits(['click']);
</script>

<style scoped>
.city-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  cursor: default;
  position: relative;
  transition: all 0.3s ease;
}

.city-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  transition: opacity 0.3s ease;
}

.city-content.coming-soon-content {
  opacity: 0.4;
}

.coming-soon-tag {
  position: absolute;
  top: -8px;
  right: -8px;
  background: linear-gradient(135deg, #6c757d, #495057);
  color: white;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.city-image {
  width: 110px;
  height: 110px;
  overflow: hidden;
  border-radius: 50%;
  border: 3px solid #F8AE62;
  transition: all 0.3s ease;
}

.city-button.coming-soon .city-image {
  border-color: #ddd;
}

.city-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.city-name {
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.5em;
  color: #EB5763;
  text-align: center;
  transition: color 0.3s ease;
}

.city-button.coming-soon .city-name {
  color: #999;
}
</style> 